// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_free = /** @type {(inputs: {}) => string} */ () => {
	return `Free`
};

const el_free = /** @type {(inputs: {}) => string} */ () => {
	return `Δωρεάν`
};

const ru_free = /** @type {(inputs: {}) => string} */ () => {
	return `Бесплатно`
};

const he_free = /** @type {(inputs: {}) => string} */ () => {
	return `חינם`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const free = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.free(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("free", locale)
	if (locale === "en") return en_free(inputs)
	if (locale === "el") return el_free(inputs)
	if (locale === "ru") return ru_free(inputs)
	if (locale === "he") return he_free(inputs)
	return "free"
};